import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLayoutModule, CommonUIModule } from '@sdbn/common';

import { MaterialModule } from '@sdbn/appclient';
import { AttributeGroupComponent } from './components/attribute-group/attribute-group.component';
import { CommonTranslationModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberInputModule } from '@sdbn/appclient';
import { ArticleSelectionComponent } from './components/article-selection/article-selection.component';



@NgModule({
  declarations: [
    AttributeGroupComponent,
    ArticleSelectionComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonUIModule,
    CommonTranslationModule,
    NumberInputModule
  ],
  exports: [
    AttributeGroupComponent,
    ArticleSelectionComponent
  ]
})
export class ErpCommonModule { }
